import { FormattedMessage } from 'react-intl'

import { EditTranslations } from './EditTranslations'
import { useMessage } from './hooks'

export const Translation = ({ className = '', id = '', values = {}, ...restOfProps }) => {
  const croppedId = useMessage(id)

  if (!croppedId) {
    return null
  }

  return (
    <span className={className}>
      <FormattedMessage id={croppedId} values={{ ...values, ...restOfProps }} />
      <EditTranslations croppedId={croppedId} />
    </span>
  )
}
